const IconSortLinear = ({ color = '#242a45', height = 12, width = 14 }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M13 1H1M11.2 5H2.8M9.4 9H4.6" stroke={color} strokeLinecap="round" />
    </svg>
  );
};

export { IconSortLinear as default, IconSortLinear };
